/**
 * @public
 */
export const LogLevels = {
    trace: 10,
    debug: 20,
    info: 30,
    warn: 40,
    error: 50
};
/**
 * A very simple {@link PowerSyncLogger} implementation forwarding messages to `console.log`.
 *
 * @param options - Options to configure a minimum severity of the logger or a prefix to make messages more recognizable.
 * @public
 */
export function createConsoleLogger(options) {
    const { prefix = 'PowerSync', minLevel = LogLevels.info } = options ?? {};
    return {
        prefix,
        minLevel,
        log({ level, message, error }) {
            if (level < this.minLevel)
                return;
            let emitter = console.log;
            if (level >= LogLevels.error) {
                emitter = console.error;
            }
            else if (level >= LogLevels.warn) {
                emitter = console.warn;
            }
            else if (level >= LogLevels.info) {
                emitter = console.info;
            }
            const messageWithPrefix = `[${prefix}]: ${message}`;
            if (error) {
                emitter(messageWithPrefix, error);
            }
            else {
                emitter(messageWithPrefix);
            }
        }
    };
}
//# sourceMappingURL=Logger.js.map